<template>
  <div id="Marketing">
    <Header :white="true" />
    <div class="mkt-body gradientBK">
      <div class="header-title">
        <div class="cont">
          <p class="titulo">Digital marketing</p>
          <p class="descrp">
            Todo comienza con una idea.<br class="nona" />
            Una idea se vuelve una historia.<br />
            Y esa historia se convierte en un canal. Que conquista, conecta,
            impacta.
          </p>
          <a href="#scrolled">
            <ScrollBehind />
          </a>
        </div>
        <div class="items-cont">
          <img src="../assets/services/s3/img1.png" alt="img" class="im1" />
          <img src="../assets/services/s3/img2.png" alt="img" class="im2" />
          <img src="../assets/services/s3/img3.png" alt="img" class="im3" />
          <img src="../assets/services/s3/img4.png" alt="img" class="im4" />
          <img src="../assets/services/s3/img5.png" alt="img" class="im5" />
          <img src="../assets/services/s3/img6.png" alt="img" class="im6" />
        </div>
      </div>
      <div class="sec-1">
        <div class="sec-1-cont">
          <div
            class="s1-col"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-duration="1500"
          >
            <div class="head-col" id="scrolled">
              <p class="mbottom">
                Hacemos campañas de marketing digital integrales que comuniquen
                con estrategia y creatividad los objetivos de tu marca.
              </p>
              <p>
                Contamos con un equipo multidisciplinario formado por
                redactores, creativos, diseñadores y analistas que forman un
                team extraordinario y disruptivo.
              </p>
            </div>
            <div class="points">
              <p class="titulo">Social Media</p>
              <p class="texto">Content Creation</p>
              <p class="texto">Community Management</p>
              <p class="texto">Influencer marketing</p>
              <p class="texto">Trends y estrategia</p>
            </div>
            <div class="points">
              <p class="titulo">Performance Marketing</p>
              <p class="texto">Meta Ads</p>
              <p class="texto">Google Ads</p>
              <p class="texto">Youtube Ads</p>
            </div>
            <div class="points">
              <p class="titulo">SEO</p>
              <p class="texto">Analytics</p>
              <p class="texto">Optimizacion de keywords</p>
              <p class="texto">Backlinks</p>
              <p class="texto">Ads</p>
            </div>
          </div>
          <div
            class="s1-col-2"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-duration="1500"
            data-aos-delay="500"
          >
            <div class="row-1">
              <img src="../assets/mkt1.jpg" alt="item" class="item-1" />
              <img src="../assets/mkt2.jpg" alt="item" class="item-2" />
            </div>
            <div class="row-2">
              <img src="../assets/mkt3.jpg" alt="item" class="item-3" />
            </div>
          </div>
        </div>

          <div class="ddm-sec"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">
            <p class="pc">¿No encuentras lo que necesitas?</p>
            <p class="pc"> No dudes en <a href="">hablarnos.</a></p>
            <p class="mo">¿No encuentras lo <br class="mo"> que necesitas? No dudes <br class="mo"> en <a href="">hablarnos.</a></p>
          </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../components/on-site/Header";
import Footer from "../components/on-site/Footer";
import ScrollBehind from "../components/on-site/ScrollBehind";
export default {
  components: {
    Header,
    Footer,
    ScrollBehind,
  },
  methods: {
    changeBackgroundPartners(event) {
      /***logoLegra */
      let media768 = window.matchMedia("(max-width: 768px)");
      let min768 = window.matchMedia("(min-width: 768px)");
      let divcont = document.getElementsByClassName("gradientBK")[0];
      let divcont1 = document.getElementsByClassName("logoLegra")[0];
      let number = event.target.documentElement.scrollTop;
      let offset = number * 0.09615384615384615;
      if (media768.matches) {
        if (offset <= 45) {
          divcont.style.backgroundColor = "#987EF3";
          divcont1.style.filter = "brigthness(2)";
        }
        if (offset >= 45) {
          divcont.style.backgroundColor = "#FFFFFF";
          divcont1.style.filter = "brigthness(1)";
        }
      } else if (min768.matches) {
        /**#e4e4f9 */
        if (offset <= 57) {
          divcont.style.backgroundColor = "#987EF3";
          divcont1.style.filter = "brigthness(2)";
        }
        if (offset >= 57) {
          divcont.style.backgroundColor = "#FFFFFF";
          divcont1.style.filter = "brigthness(1)";
        }
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.changeBackgroundPartners);
  },
  watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || 'Digital marketing - Legrafica';
            }
        },
  }
};
</script>
<style scoped>
.im1 {
  top: 2.344vw;
  left: 56.719vw;
  position: absolute;
  width: 18.125vw;
  height: auto;
}
.im2 {
  position: absolute;
  top: 4.01vw;
  left: 33.542vw;
  z-index: 9;
  width: 31.719vw;
  height: auto;
}
.im3 {
  top: 24.219vw;
  left: 22.448vw;
  position: absolute;
  width: 13.542vw;
  height: auto;
}
.im4 {
  position: absolute;
  top: 22.188vw;
  left: 77.135vw;
  width: 14.167vw;
  height: auto;
}
.im5 {
  position: absolute;
  width: 7.865vw;
  height: auto;
  top: 11.823vw;
  left: 14.271vw;
}
.im6 {
  top: 32.917vw;
  left: 70.885vw;
  position: absolute;
  width: 6.667vw;
  height: auto;
}

.ddm-sec {
  margin-left: auto;
  margin-right: auto;
    margin-bottom: 10.729vw;
}
.mkt-body {
  background-color: #987ef3;
}
.header-title .cont {
  /*padding: 20.26vw 0;
  margin: 0 auto;*/
  position: absolute;
  padding: 20.26vw 0 20.26vw 19.479vw;
  width: 63.958vw;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 40;
}
.header-title .titulo {
  font-family: "Gramatika-Medium";
  font-weight: 400;
  font-size: 7.813vw;
  line-height: 121.3%;
  color: #ffffff;
  text-align: center;
  margin: 0 0 3.906vw;
}
.header-title .descrp {
  font-family: "Gramatika-Medium";
  font-weight: 400;
  font-size: 1.146vw;
  line-height: 147%;
  text-align: center;
  color: #ffffff;
  margin: 0;
}
.head-col {
  margin-bottom: 5.208vw;
}
.head-col .mbottom {
  margin: 0 0 2.083vw;
}
.head-col p {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 400;
  font-size: 0.833vw;
  line-height: 179.8%;
  color: #000000;
  margin: 0;
}
.sec-1 {
  position: relative;
  padding-top: 52.292vw;
}
.sec-1-cont {
  width: 82.448vw;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 18.49vw;
}
.points {
  padding-left: 2.604vw;
  padding-bottom: 2.604vw;
  background-image: url("../assets/linea-1.svg");
  background-size: 1.563vw;
  background-repeat: no-repeat;
  position: relative;
  left: -2.604vw;
}
.points .titulo {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 700;
  font-size: 0.833vw;
  line-height: 179.8%;
  color: #ef67c2;
  margin: 0;
}
.points .texto {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 400;
  font-size: 0.833vw;
  line-height: 179.8%;
  color: #000000;
  margin: 0;
}
.s1-col {
  width: 31.615vw;
}
.s1-col-2 {
  width: 38.542vw;
}
.row-1 {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.s1-col-2 .item-1 {
  width: 14.01vw;
  height: auto;
}
.s1-col-2 .item-2 {
  width: 21.302vw;
  height: auto;
  position: relative;
  top: 1.302vw;
}
.row-2 {
  display: flex;
  justify-content: center;
  margin-top: 5.521vw;
}
.s1-col-2 .item-3 {
  width: 28.385vw;
  height: auto;
}
.nona {
  display: none;
}
@media (max-width: 768px) {
  .im1 {
    display: none;
  }
  .im2 {
    top: 13.768vw;
    left: 12.802vw;
    width: 66.425vw;
  }
  .im3 {
    top: 87.44vw;
    left: 76.812vw;
    width: 24.879vw;
}
.im4 {
    top: 25.121vw;
    left: 49.034vw;
    width: 44.928vw;
    z-index: 9;
}
.im5 {
    width: 20.29vw;
    top: 83.333vw;
    left: 2.415vw;
}
.im6 {
    top: 31.884vw;
    left: 13.043vw;
    width: 10.628vw;
    z-index: 9;
}
  .nona {
    display: block;
  }
  .header-title .cont {
    padding: 57.971vw 0 57.971vw 16.425vw;
  }
  .header-title .titulo {
    font-size: 13.285vw;
  }
  .header-title .descrp {
    font-size: 3.623vw;
    width: 68.357vw;
  }
  .sec-1-cont {
    width: 82.448vw;
    padding-bottom: 43.72vw;
    flex-direction: column;
  }
  .sec-1 {
    position: relative;
    padding-top: 199.034vw;
  }
  .s1-col {
    width: 100%;
  }
  .head-col p {
    font-size: 2.899vw;
  }
  .head-col .mbottom {
    margin: 0 0 7.246vw;
  }
  .head-col {
    margin-bottom: 25.845vw;
  }
  .points .titulo {
    font-size: 2.899vw;
  }
  .points .texto {
    font-size: 2.899vw;
  }
  .points {
    padding-left: 12.077vw;
    padding-bottom: 12.077vw;
    background-size: 7.246vw;
    left: 0;
  }
  .s1-col-2 {
    width: 100%;
  }
  .s1-col-2 .item-1 {
    width: 33.575vw;
  }
  .s1-col-2 .item-2 {
    width: 42.271vw;
    top: 4.302vw;
  }
  .s1-col-2 .item-3 {
    width: 68.116vw;
  }
  .row-2 {
    margin-top: 11.521vw;
    align-items: flex-start;
  }
   .ddm-sec{
    margin-bottom: 43.72vw;
    width: auto;
  }
}
</style>